/* eslint-disable no-shadow */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  toggleBulkEditionMode,
  selectWidget,
  unselectWidget
} from './BulkEdition.slice';
import { WidgetSelection } from './components';

const WidgetSelectionContainer = ({
  isBulkEditionMode,
  isSelected,
  selectWidget,
  unselectWidget,
  widget
}) => {

  const handleClick = () => {
    return isSelected ? unselectWidget(widget) : selectWidget(widget);
  };

  return (
    <WidgetSelection
      isVisible={isBulkEditionMode}
      isSelected={isSelected}
      onClick={handleClick}
      widgetId={widget.id}
    />
  );
};

WidgetSelectionContainer.propTypes = {
  isBulkEditionMode: PropTypes.bool,
  isSelected: PropTypes.bool,
  selectWidget: PropTypes.func,
  unselectWidget: PropTypes.func,
  widget: PropTypes.object
};

const mapStateToProps = (
  { BulkEdition: { isBulkEditionMode, selectedWidgets } },
  { widget }
) => {
  const isSelected = selectedWidgets.some(
    (selectedWidget) => selectedWidget.id === widget.id
  );

  return {
    isBulkEditionMode,
    isSelected
  };
};

const mapDispatchToProps = {
  toggleBulkEditionMode,
  selectWidget,
  unselectWidget
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WidgetSelectionContainer);
